import * as Sentry from '@sentry/react';

const ENVIRONMENT_NAME = import.meta.env.REACT_APP_SENTRY_ENVIRONMENT;
const SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN;
const PRODUCTION = import.meta.env.REACT_APP_SENTRY_ENVIRONMENT === 'production';

export const initSentry = (): void => {
  if (!SENTRY_DSN) {
    console.log('Sentry DSN not found, skipping initialization.');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Sentry.replayIntegration(),
    ],
    tracesSampleRate: PRODUCTION ? 0.1 : 1.0,
    tracePropagationTargets: [],
    // replaysSessionSampleRate: 0.1,
    // replaysOnErrorSampleRate: 1.0,
    environment: ENVIRONMENT_NAME,
  });
};
